import Svg, { SvgProps } from './Svg';

export default function FarmsIcon({ ...props }: SvgProps) {
  return (
    <Svg
      viewBox="0 0 520 478"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}>
      <path
        d="M260.002 0.612305L260.159 1.00903V150.205L260.002 150.703L108.874 255.231L0.37207 180.186L260.002 0.612305Z"
        fill="url(#paint0_linear_106_1735)"></path>
      <path
        d="M260.002 222.766L260.198 223.231V372.284L260.002 372.857L108.874 477.385L0.37207 402.34L260.002 222.766Z"
        fill="url(#paint1_linear_106_1735)"></path>
      <path
        d="M260.002 0.612427V150.703L411.13 255.231L519.632 180.186L260.002 0.612427Z"
        fill="url(#paint2_linear_106_1735)"></path>
      <path
        d="M260.002 222.766V372.857L411.13 477.385L519.632 402.34L260.002 222.766Z"
        fill="url(#paint3_linear_106_1735)"></path>
      <defs>
        <linearGradient
          id="paint0_linear_106_1735"
          x1="0.372047"
          y1="179.217"
          x2="260.002"
          y2="0.612408"
          gradientUnits="userSpaceOnUse">
          <stop stopColor="#A273FF"></stop>
          <stop offset="0.5" stopColor="#9FAEFF"></stop>
          <stop offset="1" stopColor="#AAF2E1"></stop>
        </linearGradient>
        <linearGradient
          id="paint1_linear_106_1735"
          x1="0.372075"
          y1="402.781"
          x2="260.002"
          y2="222.767"
          gradientUnits="userSpaceOnUse">
          <stop stopColor="#F7A7F9"></stop>
          <stop offset="1" stopColor="#6D28FF"></stop>
        </linearGradient>
        <linearGradient
          id="paint2_linear_106_1735"
          x1="260.002"
          y1="0.612426"
          x2="519.632"
          y2="179.908"
          gradientUnits="userSpaceOnUse">
          <stop stopColor="#EB5EDF"></stop>
          <stop offset="1" stopColor="#FFCD6B"></stop>
        </linearGradient>
        <linearGradient
          id="paint3_linear_106_1735"
          x1="519.631"
          y1="402.143"
          x2="260.002"
          y2="222.766"
          gradientUnits="userSpaceOnUse">
          <stop stopColor="#00DDFB"></stop>
          <stop offset="1" stopColor="#F7A7F9"></stop>
        </linearGradient>
      </defs>
    </Svg>
  );
}
